const {host} = require("./host");

const urlPath = (url) => {
    //!singleHost
    //    ? host + url
    //    : host.replace("{controller}", url.split('/')[2].split('?')[0]) + url
    return host.replace("{controller}", url.split("/")[2].split("?")[0]) + url;
};
exports.urlPath = urlPath;
